import { render, staticRenderFns } from "./NotificationRefresh.vue?vue&type=template&id=387e16cc"
import script from "./NotificationRefresh.vue?vue&type=script&lang=ts"
export * from "./NotificationRefresh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports